module.exports = __webpack_public_path__ + "img/filters-icon.551176dc.svg";